export function generateRuleId() {
  const r = (Math.random() + 1).toString(36).slice(2, 2 + 6);
  return r;
}
